import React, {useState} from "react";
import {Alert, Button, Form, Spinner} from "react-bootstrap";
import {ErrorMessage, Formik} from "formik";
import * as yup from "yup";

import {REGEX_FULLDOMAIN} from "../../../constants";
import {autoConnectDomainAdd} from "../../../services/custom-domain";
import CustomTooltip from "../../CustomTooltip";

const checkNoDuplicate = (domains, value = '') =>
    !domains.includes(value)

const Add = ({domains, onSuccess, onFail}) => {
    const [loading, setLoading] = useState(false);

    const schema = yup.object({
        domain: yup
            .string()
            .matches(REGEX_FULLDOMAIN, "Please enter a valid domain")
            .required('Please enter a domain')
            .test(
                'domain',
                'Domain already added',
                (value) => checkNoDuplicate(domains, value)
            ),
        owner: yup.bool()
          .oneOf([true], "You must already own this domain or have access to modify it's settings")
          .required()

    });

    const onFormSubmit = (data) => {
        setLoading(true);
        autoConnectDomainAdd(data)
            .then(({data: {domain, token, cert, cfName}}) => {
                setLoading(false);
                onSuccess(domain, token, cert, cfName, data.replaceWWW)
            })
            .catch(() => {
                setLoading(false);
                onFail()
            });
    };

    return <Formik
        validationSchema={schema}
        onSubmit={onFormSubmit}
        initialValues={{
            domain: '',
            owner: false
        }}
    >
        {({handleSubmit, handleChange, values, touched, errors}) =>
            (<Form noValidate onSubmit={handleSubmit}>
                <div className="p-3">
                    <h2 className="mb-2 bold color-purple-2 font-22">Connect custom domain</h2>
                    <div className="flex mt-3">
                        <Form.Group controlId="validationFormikDomain" style={{flex: 5}}>
                            <Form.Label className="font-small grey">Custom domain</Form.Label>
                            <Form.Control
                                name="domain"
                                type="text"
                                placeholder="e.g. mydomain.com"
                                value={values.domain}
                                onChange={handleChange}
                                isValid={touched.domain && !errors.domain}
                            />
                            <ErrorMessage name="domain" component="div" className="validation-error"/>
                        </Form.Group>
                    </div>
                    <Form.Check
                      name="owner"
                      className="mt-4"
                      type="checkbox"
                      value={values.owner}
                      onChange={handleChange}
                      label="I own this domain / I can instruct DNS changes"
                    />
                    <ErrorMessage name="owner" component="div" className="validation-error"/>
                    {values.owner && <div className="align-items-center mt-3">
                        <div className="flex">
                            <Form.Check
                              name="replaceWWW"
                              type="checkbox"
                              value={values.replaceWWW}
                              onChange={handleChange}
                              label={`Connect www.${values.domain.replace('www.', '')}`}
                            />
                            <CustomTooltip label={`Warning: this will replace anything already hosted on www.${values.domain.replace('www.', '')} (optional)`}>
                                <img className="ms-2" src="assets/icons/info-grey.svg" height="20" width="20" />
                            </CustomTooltip>
                        </div>
                        {values.replaceWWW && <div className="mt-3">
                            <Alert className="mb-0" variant="warning">
                                <Alert.Heading>
                                    <img src="assets/icons/warning.svg" height="18" />
                                    <span className="font-18 bold ms-2">Warning</span>
                                </Alert.Heading>
                                <p className="font-16">
                                    This will <b>delete</b> any existing website on {`www.${values.domain.replace('www.', '')}.`} <b>Are you sure?</b>
                                </p>
                                <p className="font-14 italic mb-0">
                                    If you only want to host on a subdomain (e.g. {`abc.${values.domain.replace('www.', '')}`}) uncheck the above box.
                                </p>
                            </Alert>
                        </div>}
                    </div>}
                    <Button
                      className="action-btn mt-4"
                      type="submit"
                      disabled={loading}
                    >
                        {loading ? <Spinner animation="border" size="sm"/> : 'CONTINUE'}
                    </Button>
                </div>
            </Form>)}
    </Formik>
}

export default Add